<template>
	<div id="header">
		<div class="greenline"></div>
		<div class="info" @mouseleave="closeMenu">
			<div class="menu_compacto float-left" @blur="closeMenu" tabindex="0">
				<div @click="openMenu(true)" class="container-bars">
					<div class="bars"></div>
					<div class="bars"></div>
					<div class="bars"></div>
				</div>
				<div class="menu" :class="[showMenu ? 'menu_show' : '']">
					<ul>
						<li @click="navigateTo($event, { path: '/overview' })" @click.middle="navigateTo($event, { path: '/overview' })" @mouseenter="subMenu()">
							{{$t('menu_overview')}}
						</li>

						<li v-if="permission('fullstats', 'select')" @click="subMenu('showFullStats')" @mouseenter="subMenu('showFullStats')">
							{{$t('menu_full_stats')}}
							<div id="menu_stats" class="submenu" :class="[showFullStats ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/statistics' })"		@click.middle="navigateTo($event, { path: '/statistics' })"			class="dropdown-item">{{$t('menu_statistics')}}</li>
								<li @click="navigateTo($event, { path: '/statisticspayment' })"	@click.middle="navigateTo($event, { path: '/statisticspayment' })"	class="dropdown-item">{{$t('menu_statistics_payment')}}</li>
								<li @click="navigateTo($event, { path: '/statschargebacks' })"	@click.middle="navigateTo($event, { path: '/statschargebacks' })"	class="dropdown-item">{{$t('menu_chargebacks')}}</li>
								<li @click="navigateTo($event, { path: '/statsforecast' })"		@click.middle="navigateTo($event, { path: '/statsforecast' })"		class="dropdown-item">{{$t('menu_forecast')}}</li>
								<li @click="navigateTo($event, { path: '/forecastcompare' })"	@click.middle="navigateTo($event, { path: '/forecastcompare' })"	class="dropdown-item">{{$t('menu_forecast_compare')}}</li>
								<li @click="navigateTo($event, { path: '/statstime' })"			@click.middle="navigateTo($event, { path: '/statstime' })"			class="dropdown-item">{{$t('menu_time')}}</li>
								<!--
									Menu comentado em 21/09/2020
									<li @click="navigateTo($event, { path: '/statsdia' })" @click.middle="navigateTo($event, { path: '/statsdia' })"  class="dropdown-item" >{{$t('menu_total_dia')}}</li>
								-->
							</div>
						</li>

						<li @click="subMenu('showSettlement')" @mouseenter="subMenu('showSettlement')">
							{{$t('menu_reports')}}

							<div id="menu_settlement" class="submenu" :class="[showSettlement ? 'menu_show' : '']">
								<li @click="navigateTo($event, {path: '/reportsettlement'})"
									@click.middle="navigateTo($event, {path: '/reportsettlement'})"
									class="dropdown-item">{{$t('menu_settlement')}}</li>

								<li @click="navigateTo($event, {path: '/reportconsolidated'})"
									@click.middle="navigateTo($event, {path: '/reportconsolidated'})"
									class="dropdown-item">{{$t('menu_consolidated')}}</li>

								<li @click="navigateTo($event, {path: '/reportpayout'})"
									@click.middle="navigateTo($event, {path: '/reportpayout'})"
									class="dropdown-item">{{$t('menu_payout')}}</li>

								<li @click="navigateTo($event, {path: '/reportfee'})"
									@click.middle="navigateTo($event, {path: '/reportfee'})"
									class="dropdown-item">{{$t('menu_fee')}}</li>

								<li @click="navigateTo($event, {path: '/reportreserve'})"
									@click.middle="navigateTo($event, {path: '/reportreserve'})"
									class="dropdown-item">{{$t('menu_reserve')}}</li>

								<li @click="navigateTo($event, {path: '/reportnotafiscal'})"
									@click.middle="navigateTo($event, {path: '/reportnotafiscal'})"
									class="dropdown-item">{{$t('menu_notafiscal')}}</li>

								<li @click="navigateTo($event, {path: '/reportnotafiscalmarkup'})"
									@click.middle="navigateTo($event, {path: '/reportnotafiscalmarkup'})"
									class="dropdown-item">{{$t('menu_notafiscal_markup')}}</li>

								<li @click="navigateTo($event, {path: '/reportrevenue'})"
									@click.middle="navigateTo($event, {path: '/reportrevenue'})"
									class="dropdown-item"
									v-if="permission('revenuereport', 'select')">{{$t('menu_revenue')}}</li>

								<li @click="navigateTo($event, {path: '/revenuegrouprange'})"
									@click.middle="navigateTo($event, {path: '/revenuegrouprange'})"
									class="dropdown-item"
									v-if="permission('revenuegrouprange', 'select')">{{$t('menu_revenuegrouprange')}}</li>

								<li @click="navigateTo($event, {path: '/reportpod'})"
									@click.middle="navigateTo($event, {path: '/reportpod'})"
									class="dropdown-item"
									v-if="permission('superpodreport', 'select')">{{$t('menu_pod_report')}}</li>
								<li
									@click="navigateTo($event, {path: '/recebivelunidade'})"
									@click.middle="navigateTo($event, {path: '/recebivelunidade'})"
									class="dropdown-item"
									v-if="permission('unidaderecebivel', 'select')">CERC {{$t('menu_unidade_recebivel')}}</li>
								<li
									@click="navigateTo($event, {path: '/fullpaymentremittance'})"
									@click.middle="navigateTo($event, {path: '/fullpaymentremittance'})"
									class="dropdown-item">{{$t('payment_remittance_title')}}</li>
							</div>
						</li>

						<li @click="subMenu('showRemittance')" @mouseenter="subMenu('showRemittance')">
							{{$t('menu_remittances')}}

							<div id="menu_remittances" class="submenu" :class="[showRemittance ? 'menu_show' : '']">
								<li @click="navigateTo($event, {path: '/remittance'})"
									@click.middle="navigateTo($event, {path: '/remittance'})"
									class="dropdown-item">{{$t('menu_remittance')}}</li>

								<li @click="navigateTo($event, { path: '/reportremittance' })"
									@click.middle="navigateTo($event, { path: '/reportremittance' })"
									v-if="permission('remittancereport', 'select')"
									class="dropdown-item">{{$t('menu_remittance_report')}}</li>

								<li @click="navigateTo($event, { path: '/feeremittance' })"
									@click.middle="navigateTo($event, { path: '/feeremittance' })"
									v-if="permission('feeremittance', 'select')"
									class="dropdown-item">{{$t('menu_fee_remittance')}}</li>

								<li @click="navigateTo($event, { path: '/proforma' })"
									@click.middle="navigateTo($event, { path: '/proforma' })"
									v-if="permission('proforma', 'select')"
									class="dropdown-item">{{$t('menu_remittance_proforma')}}</li>

								<li @click="navigateTo($event, { path: '/proformapayment' })"
									@click.middle="navigateTo($event, { path: '/proformapayment' })"
									v-if="permission('proformapayment', 'select')"
									class="dropdown-item">{{$t('menu_remittance_proformapayment')}}</li>

								<li @click="navigateTo($event, { path: '/consolidatetaxid' })"
									@click.middle="navigateTo($event, { path: '/consolidatetaxid' })"
									v-if="permission('consolidatetaxid', 'select')"
									class="dropdown-item">{{$t('menu_remittance_consolidatetaxid')}}</li>

								<li @click="navigateTo($event, { path: '/invoice' })"
									@click.middle="navigateTo($event, { path: '/invoice' })"
									v-if="permission('invoice', 'select')"
									class="dropdown-item">{{$t('menu_remittance_invoice')}}</li>

								<li @click="navigateTo($event, { path: '/processment' })"
									@click.middle="navigateTo($event, { path: '/processment' })"
									v-if="permission('processment', 'select')"
									class="dropdown-item">{{$t('menu_remittance_processment')}}</li>
								<li @click="navigateTo($event, { path: '/invoicepayment' })"
									@click.middle="navigateTo($event, { path: '/invoicepayment' })"
									v-if="permission('invoicepayment', 'select')"
									class="dropdown-item">{{$t('payment_invoice_title')}}</li>
							</div>
						</li>

						<li @click="openResources()" v-if="permission('resource', 'select')" @mouseenter="subMenu()">
							{{$t('menu_resources')}}
						</li>

						<li @click="navigateTo($event, { path: '/supernews' })" @click.middle="navigateTo($event, { path: '/supernews' })" @mouseenter="subMenu()" v-if="permission('supernews', 'select')">
							{{$t('menu_news')}}
						</li>

						<li @click="navigateTo($event, { path: '/calendar' })" @click.middle="navigateTo($event, { path: '/calendar' })" @mouseenter="subMenu()" v-if="permission('supercalendar', 'select')">
							{{$t('menu_calendar')}}
						</li>

						<li @click="navigateTo($event, { path: '/graphic' })" @click.middle="navigateTo($event, { path: '/graphic' })" @mouseenter="subMenu()" v-if="permission('supergraphics', 'select')">
							{{$t('menu_graphics')}}
						</li>

						<li @click="subMenu('showUser')" @mouseenter="subMenu('showUser')">
							{{$t('menu_user')}}

							<div id="menu_user" class="submenu" :class="[showUser ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/usuario' })"				@click.middle="navigateTo($event, { path: '/usuario' })"			class="dropdown-item" v-if="permission('user',					'select')">{{$t('menu_user')}}</li>
								<li @click="navigateTo($event, { path: '/permissao' })"				@click.middle="navigateTo($event, { path: '/permissao' })"			class="dropdown-item" v-if="permission('permission',			'select')">{{$t('menu_permission')}}</li>
								<li @click="navigateTo($event, { path: '/permissaoespecial' })"		@click.middle="navigateTo($event, { path: '/permissaoespecial' })"	class="dropdown-item" v-if="permission('permissionespecial',	'select')">{{$t('menu_especial_permission')}}</li>
								<li @click="navigateTo($event, { path: '/grupopermissao' })"		@click.middle="navigateTo($event, { path: '/grupopermissao' })"		class="dropdown-item" v-if="permission('permissiongrupo',		'select')">{{$t('menu_permission_group')}}</li>
								<li @click="navigateTo($event, { path: '/permissaomerchant' })"		@click.middle="navigateTo($event, { path: '/permissaomerchant' })"	class="dropdown-item" v-if="permission('permissionmerchant',	'select')">{{$t('menu_permission_merchant')}}</li>
								<li @click="navigateTo($event, { path: '/permissaocampo' })"		@click.middle="navigateTo($event, { path: '/permissaocampo' })"		class="dropdown-item" v-if="permission('permissioncampo',		'select')">{{$t('menu_permission_campo')}}</li>
							</div>
						</li>

						<li @click="subMenu('showUpdateInformation')"  @mouseenter="subMenu('showUpdateInformation')">
							{{$t('menu_update_information')}}

							<div id="menu_account" class="submenu" :class="[showUpdateInformation ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/superaccount' })"				@click.middle="navigateTo($event, { path: '/superaccount' })"				class="dropdown-item" v-if="permission('superaccount',			'select')">{{$t('menu_update_information')}}</li>
								<li @click="navigateTo($event, { path: '/superaccountestabcom' })"		@click.middle="navigateTo($event, { path: '/superaccountestabcom' })"		class="dropdown-item" v-if="permission('superaccountestabcom',	'select')">{{$t('menu_account_estab_comercial')}}</li>
								<li @click="navigateTo($event, { path: '/superaccountgroup' })"			@click.middle="navigateTo($event, { path: '/superaccountgroup' })"			class="dropdown-item" v-if="permission('superaccountgroup',		'select')">{{$t('menu_account_group')}}</li>
								<li @click="navigateTo($event, { path: '/superaccountuser' })"			@click.middle="navigateTo($event, { path: '/superaccountuser' })"			class="dropdown-item" v-if="permission('superaccountuser',		'select')">{{$t('menu_account_user')}}</li>
								<li @click="navigateTo($event, { path: '/superaccountrevenuegroup' })"	@click.middle="navigateTo($event, { path: '/superaccountrevenuegroup' })"	class="dropdown-item" v-if="permission('superrevenuegroup',		'select')">{{$t('menu_account_revenue_group')}}</li>
								<li @click="navigateTo($event, { path: '/superconfig' })"				@click.middle="navigateTo($event, { path: '/superconfig' })"				class="dropdown-item" v-if="permission('superconfig',			'select')">{{$t('menu_super_config')}}</li>
								<li @click="navigateTo($event, { path: '/pixconfig' })"					@click.middle="navigateTo($event, { path: '/pixconfig' })"					class="dropdown-item" v-if="permission('superpixconfig',		'select')">{{$t('menu_pixconfig')}}</li>
								<li @click="navigateTo($event, { path: '/blocklistpixroaming' })"		@click.middle="navigateTo($event, { path: '/blocklistpixroaming' })"		class="dropdown-item" v-if="permission('superblocklistroaming',	'select')">{{$t('menu_blocklist_roamingpay_super')}}</li>
								<li @click="navigateTo($event, { path: '/taxidblocked' })"				@click.middle="navigateTo($event, { path: '/taxidblocked' })"				class="dropdown-item" v-if="permission('superaccount',			'select')">{{$t('menu_taxid_blocked')}}</li>
								<li @click="navigateTo($event, { path: '/pixautomaticoconfig' })"		@click.middle="navigateTo($event, { path: '/pixautomaticoconfig' })"		class="dropdown-item" v-if="permission('superpixautomaticoconfig', 'select')">{{$t('menu_pixautomaticoconfig')}}</li>
								<li @click="navigateTo($event, { path: '/rabbitmqqueue' })"				@click.middle="navigateTo($event, { path: '/rabbitmqqueue' })"				class="dropdown-item" v-if="permission('superrabbitmqqueue',	'select')">{{$t('menu_rabbitmqqueue')}}</li>
								<li @click="navigateTo($event, { path: '/costconfiguration' })"			@click.middle="navigateTo($event, { path: '/costconfiguration' })"			class="dropdown-item" v-if="permission('costconfiguration',		'select')">{{$t('menu_cost_configuration')}}</li>
								<li @click="navigateTo($event, { path: '/superfeesconfiguration'})"		@click.middle="navigateTo($event, { path: '/superfeesconfiguration' })"		class="dropdown-item" v-if="permission('superprocessfee',		'select')">{{$t('menu_feesconfig')}}</li>
								<li @click="navigateTo($event, { path: '/modelocontrato'})"				@click.middle="navigateTo($event, { path: '/superfeesconfiguration' })"		class="dropdown-item" v-if="permission('modelocontrato',		'select')">{{$t('menu_modelo_contrato')}}</li>
							</div>
						</li>

						<li @click="subMenu('showMenuPagShield')"
							@mouseenter="subMenu('showMenuPagShield')">

							{{$t('menu_pagshield')}}

							<div id="menu_pagshield" 
								class="submenu" 
								:class="[showMenuPagShield ? 'menu_show' : '']"
							>
							
								<li @click="navigateTo($event, { path: '/pagshield/decision-list-merchants' })"
									@click.middle="navigateTo($event, { path: '/pagshield/decision-list-merchants' })"
									class="dropdown-item">

									{{$t('menu_pagshield_decisionlist_super')}}

								</li>

								<li @click="navigateTo($event, { path: '/pagshield/decision-list-global' })"
									@click.middle="navigateTo($event, { path: '/pagshield/decision-list-global' })"
									class="dropdown-item">

									{{$t('menu_pagshield_merchant_decisionlist')}}

								</li>
							</div><!-- pagshield -->
						</li>

						<li @click="subMenu('showRoamingPay')" @mouseenter="subMenu('showRoamingPay')">
							{{$t('menu_roamingpay')}}

							<div id="menu_roamingpay" class="submenu" :class="[showRoamingPay ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/connectorprocessor' })"			@click.middle="navigateTo($event, { path: '/connectorprocessor' })"			class="dropdown-item" v-if="permission('accountpayment',	'select')">{{$t('menu_connector_processor')}}</li>
								<li @click="navigateTo($event, { path: '/connectorprocessormerchant' })"	@click.middle="navigateTo($event, { path: '/connectorprocessormerchant' })"	class="dropdown-item" v-if="permission('accountpayment',	'select')">{{$t('menu_connector_processor_merchant')}}</li>
							</div>
						</li>
					</ul>
				</div>
			</div>

			<div class="logo float-left">
				<img src="~@/assets/img/logo-fundo-azul-sem-icone.svg">
			</div>

			<!-- exibe em telas maiores que 768px -->
			<div class="float-right secondary_menu">
				<div class="float-left profile_link">
					<span>
						<img src="~@/assets/img/icon-profile.png">
						<span>{{username}}</span>
					</span>
				</div>

				<div class="float-left logout">
					<router-link to="/login?btnclick=1">
						<span>
							<img src="~@/assets/img/icon-logout.png">
						</span>
					</router-link>
				</div>
			</div>

			<div class="right-navbar-mobile float-right" ref="dropdownMenu">
				<div class="float-left">
					<span @click="openDropdown = !openDropdown">
						<img src="~@/assets/img/icon-user.svg" class="icon-user">
					</span>
				</div>
				<div class="custom-menu-dropdown" v-if="openDropdown">
					<ul>
						<li class="username" @click="openDropdown = false">
							<router-link to="">
								{{username}}
							</router-link>
						</li>
						<li class="dropdown-divider"></li>
						<li class="dropdown-logout">
							<router-link to="/login?btnclick=1"> Sair
								<img src="~@/assets/img/icon-logout.svg">
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>

	</div>

</template>


<script>
var aux_timeout;

export default {
	name: 'MenuView',

	data(){
		return {
			"lang": {},
			"logado": false,
			"username": '',
			"merchant_name": '',
			"merchant_number": '',
			"merchant_status": '',
			"xpp": '',
			"perm": {
                "user": {},
                "perm": {},
                "especial": {}
			},

			"showMenu":					false,
			"showFullStats":			false,
			"showSettlement":			false,
			"showRemittance":			false,
			"showUser":					false,
			"showUpdateInformation":	false,
			"showRoamingPay":			false,
			"openDropdown":				false,
			"showMenuPagShield":		false,
		}
	},

	beforeMount(){
		this.$cookie.set('merchant_name', "", {"SameSite": "None", "Secure": ""});
		this.perm = JSON.parse(localStorage.getItem('perm'));
	},

	mounted(){

		let progress = document.getElementById('loaderProgress').children[0];
		progress.innerHTML = "";

		this.username 	= this.$cookie.get('username');
		this.xpp 		= this.$cookie.get('xpp');

		let token = this.$cookie.get('token');

		if(!token){
			this.$helper.pushRouteTo({ name: 'Login' });
		}else{
			this.logado = true;
			this.obtemInfoUser();
		}

	},

	created(){
		document.addEventListener('click', this.documentClick)
    },

    destroyed(){
		document.removeEventListener('click', this.documentClick)
	},

	methods:{

		menuselected(opcao){
			let ret = false;

			if(this.$route.path == opcao){
				ret = true;
			}

			return ret;
		},

		obtemInfoUser(){

			// Busca as informações sobre o merchant selecionado/logado
			var data = new FormData();
			data.append("class", 	"Usuario");
			data.append("token", 	this.$cookie.get('token'));
			data.append("username", this.$cookie.get('username'));
			data.append("method", 	"getInfoUsuario");

			this.$helper.axios().post('', data)
				.then(
					(response) => {
						this.$cookie.set('rep_format',	response.data.rep_format, {"SameSite": "None", "Secure": ""});
					}
				)
				.catch(
					(error) => {
						this.$helper.callback_error(error);
					}
				);
		},

		navigateTo(event, params){
			// fecha o menu
			this.menuHideClickRoute();

			// compara os paths para evitar erro de NavigationDuplicated
            let from  = this.$route.fullPath;
			let to    = this.$router.resolve(params).route.fullPath;

			// ctrl + click ou botão do meio do mouse
			if(event.ctrlKey === true || event.button === 1){
				let routeData = this.$router.resolve(params);
				window.open(routeData.href, '_blank');
			}else{
				if(from !== to){
					// sendo diferente segue a rota
					this.$router.push(params)
				}
			}
		},

		menuHideClickRoute(){
			clearTimeout(aux_timeout);

			window.setTimeout(() => {
				this.showMenu				= false;
				this.showFullStats			= false;
				this.showSettlement			= false;
				this.showRemittance			= false;
				this.showUser				= false;
				this.showUpdateInformation	= false;
				this.showMenuPagShield		= false;
				this.showMenuPagShieldLists = false;
				this.showRoamingPay			= false;
			}, 210);
		},

		subMenu(el = null){
			this.showFullStats			= false;
			this.showSettlement			= false;
			this.showRemittance			= false;
			this.showUser				= false;
			this.showUpdateInformation	= false;
			this.showMenuPagShield		= false;
			this.showMenuPagShieldLists = false;
			this.showRoamingPay			= false;

			if(el == null){
				return;
			}

			this[el] = !this[el];
		},

		openMenu(canClose){
			clearTimeout(aux_timeout);

			if(canClose){
				this.showMenu=!this.showMenu;
			}else{
				setTimeout(() => {
					this.showMenu = true;
				}, 200);
			}

			document.querySelector(".menu_compacto").focus();
		},

		closeMenu(){
			this.menuHideClickRoute();

			clearTimeout(aux_timeout);

			aux_timeout = window.setTimeout(() => {
				this.showMenu=false;
			}, 450);
		},

		openResources(){
			window.open('https://pagbrasil.atlassian.net/wiki/spaces/PBDocs/pages/148045826/Resources', '_blank');
			this.menuHideClickRoute();
		},

		documentClick(e){
			let el		= this.$refs.dropdownMenu;
			let target	= e.target;

			if(el !== target && ! el.contains(target)){
				this.openDropdown = false;
			}
		}
	},

	filters:{
		merchant_status_translate(value){
			if(!value){
				return '';
			}

			value = value.toString();

			var ret = '';

			if(value == 'T'){
				ret = 'TEST';
			}else if(value == '-' || value == 'I'){
				ret = 'CLOSED';
			}else if(value == '#'){
				ret = 'MAINTENANCE';
			}else{
				ret = 'LIVE';
			}

			return ret;
		}
	}
}

</script>
